import React from 'react';
import {
  ConfirmSignIn as BaseConfirmSignIn
} from 'aws-amplify-react';
import AuthWrapper from './AuthWrapper';
import ConfirmSignInForm from './ConfirmSignIn/ConfirmSignInForm';

export default class ConfirmSignIn extends BaseConfirmSignIn {
  componentDidUpdate(prevProps) {
    if (prevProps.authState !== this.props.authState && prevProps.authState === 'confirmSignIn') {
      this.setState({
        working: false,
        errorMessage: false
      });
    }
  }

  error = errorMessage => {
    setTimeout(() => {
      this.setState({
        working: false,
        errorMessage: this.errorMessage(errorMessage)
      });
    }, 1000);
  };

  handleSubmit = ({email = false, code}) => {
    if (email) {
      this.inputs.username = email;
    }
    this.inputs.code = code;

    this.setState({
      working: true,
      errorMessage: false,
    }, () => {
      this.confirm();
    });
  };

  showComponent() {
    const {
      hide
    } = this.props;
    const {
      errorMessage = false,
      working = false,
      mfaType
    } = this.state || {};

    if (hide && hide.includes(ConfirmSignIn)) {
      return null;
    }

    return (
      <AuthWrapper
        title={`Confirm ${mfaType} Code`}
      >
        <ConfirmSignInForm
          onSubmit={this.handleSubmit}
          changeState={this.changeState}
          errorMessage={errorMessage}
          working={working}
        />
      </AuthWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Authentication/ConfirmSignIn.js